<template>
  <div class="">
    <!-- 查询表单 -->
    <div>
      <el-form ref="queryParamForm" :model="queryParamForm" label-width="100px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="回收商名称">
              <el-input
                clearable
                v-model="queryParamForm.name"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="回收商联系人">
                <el-input
                clearable
                v-model="queryParamForm.contactPerson"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-button type="primary" @click="getServiceProviderListSearch"
              >查询</el-button
            >
            <el-button type="primary" @click="addBasePrice" v-if="userInfo.data.roleId!=9">创建</el-button>
            <!-- <el-button type="primary">批量导出</el-button> -->
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-top: 20px;">
      <!-- 表格 -->
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="code" label="编号"> </el-table-column>
        <el-table-column prop="name" label="回收商名称">
        </el-table-column>
        <el-table-column prop="contactPerson" label="联系人"> </el-table-column>
        <el-table-column prop="contactNumber" label="联系电话"> </el-table-column>
         <el-table-column prop="systemQuotes" label="是否系统报价">
          <template slot-scope="scope">
            <span v-if="scope.row.systemQuotes === 1">是</span>
            <span v-else>否</span>
          </template>
        </el-table-column>
         <el-table-column prop="defaults" label="是否默认回收商">
          <template slot-scope="scope">
            <span v-if="scope.row.defaults === 1">是</span>
            <span v-else>否</span>
          </template>
        </el-table-column>
        <el-table-column prop="dispatchWay" label="多派/单派">
          <template slot-scope="scope">
            <span v-if="scope.row.dispatchWay === 0">多派</span>
            <span v-else>单派</span>
          </template>
        </el-table-column>
        <el-table-column prop="quoteStatus" label="是否允许报价">
          <template slot-scope="scope">
            <span v-if="scope.row.quoteStatus === 0">启用</span>
            <span v-else>禁止</span>
          </template>
        </el-table-column>
          <el-table-column prop="minWalletPrice" label="最低余额">
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间"> </el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 1">启用</span>
            <span v-else>不启用</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" v-if="userInfo.data.roleId!=9">
          <template slot-scope="scope">
            <el-button @click="editormodel(scope.row)" type="text" size="small"
              >编辑</el-button
            >
            <el-button
              @click="changeStatus(scope.row, 1)"
              type="text"
              size="small"
              v-if="scope.row.status === 0"
              >启用</el-button
            >
            <el-button
              @click="changeStatus(scope.row, 0)"
              type="text"
              size="small"
              style="color: red;"
              v-else
              >不启用</el-button
            >
            <el-button @click="deleteServiceProvider(scope.row.id)" type="text" size="small" style="color: red;">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        style="margin-top: 20px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal"
      >
      </el-pagination>
    </div>

    <!-- 修改或新建对话框 -->
    <el-dialog
      :title="
        dlgType === 'change'
          ? '编辑回收商'
          : '新建回收商'
      "
      :visible.sync="isDlg"
      width="700px"
    >
      <div style="margin: 20px;">
        <div>
          <el-form
            ref="editServiceProviderForm"
            :model="editServiceProviderForm"
            :rules="editorFormRules"
            label-width="120px"
          >
            <el-form-item label="编号" v-if="dlgType === 'change'">
              <el-input
                clearable
                v-model="editServiceProviderForm.code"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item label="回收商名称" prop="name">
              <el-input clearable v-model="editServiceProviderForm.name" :disabled="dlgType === 'change'"></el-input>
            </el-form-item>
            <el-form-item label="联系人" prop="contactPerson">
               <el-input clearable v-model="editServiceProviderForm.contactPerson"></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="contactNumber">
              <el-input clearable v-model="editServiceProviderForm.contactNumber"></el-input>
            </el-form-item>
            <el-form-item
              label="是否系统报价"
              prop="systemQuotes"
            >
              <el-select
                style="width:100%"
                v-model="editServiceProviderForm.systemQuotes"
                :loading="loading"
              >
                <el-option
                  v-for="item in systemQuoteOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
                    <el-form-item
              label="是否默认回收商"
              prop="defaults"
            >
              <el-select
                style="width:100%"
                v-model="editServiceProviderForm.defaults"
                :loading="loading"
              >
                <el-option
                  v-for="item in defaultsOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="派单方式"
              prop="dispatchWay"
            >
              <el-radio-group
                style="width:100%"
                v-model="editServiceProviderForm.dispatchWay"
                :loading="loading"
              >
                <el-radio
                  v-for="item in dispatchWayList"
                  :key="item.id"
                  :label="item.id"
                >
                {{ item.name }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="是否允许报价" prop="quoteStatus">
                <el-radio v-model="editServiceProviderForm.quoteStatus" :label="0" >启用</el-radio>
                <el-radio v-model="editServiceProviderForm.quoteStatus" :label="1">禁用</el-radio>
              </el-form-item>
            <el-form-item label="余额限制" prop="minWalletPrice">
                <el-input v-model="editServiceProviderForm.minWalletPrice"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div style="text-align: center;">
          <el-button
            type="primary"
            style="margin: 30px 20px;"
            @click="submitEditor"
            >确定</el-button
          >
          <el-button style="margin: 10px 20px;" @click="closeEditormodelDlg"
            >暂不</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      // 查询数据
      queryParamForm: {
        contactPerson: null,
        name: null,
      },
      systemQuoteOptions:[{id:0,name:"否"},{id:1,name:"是"}],
      defaultsOptions:[{id:0,name:"否"},{id:1,name:"是"}],
      dispatchWayList:[{id:0,name:"毎单同时给所有报价员派单"},{id:1,name:"毎单仅派给一位报价员"}],
      // 表格数据
      tableTotal: 0,
      tableData: [],
      pageSize: 10,
      currentPage: 1,

      // 新建编辑对话框数据
      userInfo:{},

      isDlg: false,
      editServiceProviderForm: {
        id: null,
        code: null,
        name: null,
        contactPerson: null,
        contactNumber: null,
        systemQuotes: 0,
        defaults:0,
        dispatchWay: 1
      },

      editorFormRules: {
        name: [
          { required: true, message: "请输入回收商名称", trigger: "change" },
        ],
        contactPerson: [
          { required: true, message: "请输入联系人", trigger: "change" },
        ],
        contactNumber: [{ required: true, message: "请输入联系电话", trigger: "change" }],
      },

      dlgType: "change",

      // 选择
      loading: false,
    };
  },
  watch: {},
  computed: {},
  methods: {
     deleteServiceProvider(id){
      let self = this
        self.$confirm('是否删除').then(() => {
             self.$api.deleteServiceProvider({id:id}).then(res=>{
           if(res.code === 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
             this.getServiceProviderListSearch()
          }
      })
      })
 
    },
    // 分页函数
    handleSizeChange(val) {
      console.log(val);
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1);
    },
    handleCurrentChange(val) {
      this.currentPage = val;

      // 重新请求表格数据
      this.getServiceProviderListSearch();
    },

    // 获取表格数据
    getServiceProviderListSearch() {
      let self = this;
      self.$api
        .serviceProviderListSearch({
          page: self.currentPage,
          size: self.pageSize,
          contactPerson: self.queryParamForm.contactPerson || null,
          name: self.queryParamForm.name || null,
        })
        .then((res) => {
          self.tableData = res.data.records || [];
          self.tableTotal = res.data.total;
        });
    },

    // 添加
    addBasePrice() {
      this.dlgType = "new";
      this.editServiceProviderForm=this.$options.data().editServiceProviderForm;
      this.$nextTick(()=>{
          this.$refs['editServiceProviderForm'].clearValidate()
      })
      this.isDlg = true;
    },

    // 修改
    editormodel(row) {
      let self = this;
      self.dlgType = "change";
      self.editServiceProviderForm = JSON.parse(JSON.stringify(row));
      this.isDlg = false;
      this.$nextTick((e) => {
        self.isDlg = true;
      });
    },

    // 关闭编辑对话框
    closeEditormodelDlg() {
      this.isDlg = false;
    },

    // 提交编辑（新建或者修改）
    submitEditor() {
      let self = this;
      this.$refs["editServiceProviderForm"].validate((valid) => {
        if (valid) {
          let params = this.editServiceProviderForm;
          self.$api.updateServiceProvider(params).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              self.getServiceProviderListSearch();
              self.closeEditormodelDlg();
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    changeStatus(row, newStatus) {
      let self = this;
      row.status = newStatus;
      row.modelId = null;
      this.$api.updateServiceProvider(row).then((res) => {
        if (res.code === 200) {
          this.$message({
            message: "修改成功",
            type: "success",
          });
          self.getServiceProviderListSearch();
        }
      });
    },
  },
  created() {},
  mounted() {
    let self = this;
    self.getServiceProviderListSearch();
    self.userInfo = JSON.parse(localStorage.getItem('userInfo'))
  },
};
</script>
<style lang="less" scoped>
</style>
